import classes from "./TableInfo.module.scss";

const TableInfo = ({ leftText, rightText }) => {
  return (
    <div className={classes.TableInfo}>
      <span className={classes.InfoType}>{leftText} </span>
      <span className={classes.Info}>{rightText}</span>
    </div>
  );
};

export default TableInfo;
